/**
 * @file   src\components\HeaderButtons\Introductions.js
 * @brief  This file is responsible for introduction section in page header
 * @date   June, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React, { useState, useEffect, useRef } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { useNavigate } from "react-router-dom";
import { pageURLs } from "../../constants/pageURLs";
import BedIcon from "../../images/bed-icon.svg";
import BathIcon from "../../images/bath-icon.svg";
import SqftIcon from "../../images/sqft-icon.svg";
import noImage from "../../images/no-image-small.png";
import profImg from "../../images/intro-prof-placeholder.svg";
import WantAdMoreIcon from "../../images/want-ad-more-icon.svg";
import IntroductionSkeleton from "./IntroductionSkeleton";
import moment from "moment";
import _ from "lodash";
import {
  filterArray,
  getpropertyName,
  removeDecimalZeros,
  setLocalStorage,
  thousandSeperatedValue,
  timeAgo,
  checkTutorialDisplayStatus,
  saveTutorialStatusToLocal,
  getLocalStorage,
} from "../../helpers/common";
import {
  IS_LAND,
  LOT_TYPES,
  WANT_AD_KEY,
  USER_INFO_KEY,
} from "../../constants/common";
import JoyRide, { STATUS } from "react-joyride";
import DocumentationTutorial from "../Tutorial/DocumentationTutorial";
import { saveTutorialStatus } from "../../services/commonServices";
import IntroductionTutorialIcon from "../../images/tut-firstintro-icon.svg";

const Introductions = (props) => {
  const navigate = useNavigate();
  const tutorialPage = 2;

  const [displayTutorial, setDisplayTutorial] = useState(false);
  const [sessionData, setSessionData] = useState(
    getLocalStorage(USER_INFO_KEY)
  );
  const {
    list,
    updateIntroStateonHover,
    updateIntroPageOnScroll,
    isLoadIntroList,
  } = props;
  const isListItems = list?.length > 0;
  const myRef = useRef(null);
  const classArray = [
    "profile-bg-green",
    "profile-bg-orange",
    "profile-bg-meroon",
    "profile-bg-paleblue",
    "profile-bg-turquoise",
    "profile-bg-green-variant1",
    "profile-bg-yellow-turmeric",
    "profile-bg-blue-variant1",
    "profile-bg-orange-variant1",
    "profile-bg-blue-variant2",
    "profile-bg-purple-variant1",
    "profile-bg-blue-variant3",
    "profile-bg-turquoise-variant1",
    "profile-bg-turquoise-variant2",
    "profile-bg-meroon-variant1",
    "profile-bg-violet-variant1",
    "profile-bg-skyblue-variant1",
    "profile-bg-turquoise-variant3",
    "profile-bg-yellow-variant2",
    "profile-bg-rose-variant1",
  ];

  let arrayCount = 0;

  const handleScroll = () => {
    const el = myRef.current;
    const scrollHeight = el.scrollHeight;
    const scrollTop = el.scrollTop;
    const clientHeight = el.clientHeight;
    if (
      scrollHeight !== clientHeight &&
      scrollTop !== 0 &&
      Math.abs(scrollHeight - (scrollTop + clientHeight)) <= 1
    ) {
      updateIntroPageOnScroll();
    } else if (scrollTop === 0 && scrollHeight !== clientHeight) {
    }
  };

  const viewIntroductions = (wantAdId, introId) => {
    setLocalStorage(WANT_AD_KEY, { wantAdId: wantAdId, introId: introId });
    navigate(pageURLs.wantAdDetails);
  };

  useEffect(() => {
    if (checkTutorialDisplayStatus(tutorialPage)) {
      setTimeout(function () {
        setDisplayTutorial(true);
      }, 100);
    }
  }, [isListItems]);

  const [tutorialSteps, setTutorialSteps] = useState([
    {
      target: ".outer-property-wrap",
      disableBeacon: true,
      placement: "left",
      title: "You received your first introduction!",
      icon: IntroductionTutorialIcon,
      content: "Click to view the preview of this property.",
      hideCloseButton: true,
      showProgress: false,
      showSkipButton: false,
    },
  ]);
  //Tutorial tooltip
  const TutorialToolTip = ({
    continuous,
    index,
    step,
    backProps,
    closeProps,
    primaryProps,
    tooltipProps,
    size,
    isLastStep,
    skipProps,
  }) => (
    <>
      <div {...tooltipProps}>
        <DocumentationTutorial
          continuous={continuous}
          index={index}
          step={step}
          backProps={backProps}
          skipProps={skipProps}
          primaryProps={primaryProps}
          isLastStep={isLastStep}
          size={size}
          finalStepBtn={"Got It!"}
          hideBtns={true}
          hideCounter={true}
        />
      </div>
    </>
  );
  //Tutorial status call back
  const handleJoyrideCallback = async (data) => {
    const { action, index, status, type, lifecycle } = data;
    console.log("here", action);
    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      setDisplayTutorial(false);
      //Need to call API
    }
    if (index == 0 && action == "update") {
      saveTutorialStatusToLocal(tutorialPage);
      if (sessionData && sessionData?.userInfo?.userId) {
        await saveTutorialStatus(tutorialPage, 1); //Save status
      }
    }
  };

  return (
    <>
      <div className="top-links-header mb-0">
        {displayTutorial ? (
          <JoyRide
            steps={tutorialSteps}
            tooltipComponent={TutorialToolTip}
            continuous
            callback={handleJoyrideCallback}
            disableScrolling={true}
            isFixed={true}
            run={true}
          />
        ) : (
          ""
        )}
        <h6>Introductions</h6>
        {isListItems && (
          <div className="side-nav-wrap position-relative">
            <Dropdown
              id="inner-introduction-btn"
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <Dropdown.Toggle id="dropdown-basic555" variant="" align="end">
                <img src={WantAdMoreIcon} />
              </Dropdown.Toggle>

              <Dropdown.Menu
                className="dpdown-menu-style"
                align={"end"}
                flip={false}
                data-bs-popper="none"
              >
                <Dropdown.Item onClick={(e) => updateIntroStateonHover()}>
                  Mark all as read
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        )}
      </div>

      <div className="introductons-wrap" onScroll={handleScroll} ref={myRef}>
        {isLoadIntroList && !isListItems && (
          <div
            className="d-flex mb-20 pl-20 pr-20 pt-12"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <div className="flex-shrink-0">
              <div className="intro-prof-placeholder">
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.6056 3.50448C16.0196 3.53161 15.4357 3.68215 14.891 3.95451C14.8751 3.96239 14.8596 3.97075 14.8442 3.97958L13.19 4.93547C13.1725 4.93457 13.155 4.93419 13.1375 4.93433H2.05421C1.93826 4.93269 1.82314 4.95411 1.71555 4.99735C1.60795 5.04059 1.51002 5.10478 1.42745 5.18619C1.34487 5.2676 1.2793 5.36462 1.23455 5.47159C1.18979 5.57857 1.16675 5.69337 1.16675 5.80933C1.16675 5.92529 1.18979 6.04009 1.23455 6.14707C1.2793 6.25404 1.34487 6.35106 1.42745 6.43247C1.51002 6.51388 1.60795 6.57807 1.71555 6.62131C1.82314 6.66455 1.93826 6.68597 2.05421 6.68433H9.49969L9.11915 6.8427C9.10026 6.8504 9.08164 6.85876 9.06332 6.86776C8.09362 7.35261 7.64626 8.38548 7.74285 9.31503C7.83944 10.2446 8.5049 11.1713 9.57146 11.4376C9.98722 11.5412 10.449 11.6016 10.9523 11.6016C13.5036 11.6016 16.0036 10.8067 16.7435 10.5614C17.2301 11.1047 19.6296 13.7862 20.4315 14.6072C21.0122 15.2014 21.071 15.7816 20.9214 16.1943C20.7718 16.6069 20.4321 16.9257 19.6921 16.928C19.4911 16.9286 19.2965 16.9983 19.1408 17.1255C18.9852 17.2527 18.8782 17.4296 18.8376 17.6264C18.6194 18.6815 18.2344 18.8313 17.8418 18.9343C17.4492 19.0374 17.0705 18.948 17.0705 18.948C16.9429 18.9132 16.809 18.9077 16.679 18.932C16.549 18.9564 16.4262 19.0099 16.3198 19.0885C16.2135 19.1671 16.1263 19.2688 16.0649 19.386C16.0035 19.5031 15.9695 19.6327 15.9653 19.7649C15.9653 19.7649 15.9363 20.2167 15.7136 20.6034C15.4908 20.9902 15.2589 21.3162 14.2199 21.2027C13.9994 21.1785 13.7779 21.2389 13.6003 21.3717C13.4226 21.5045 13.302 21.6999 13.2629 21.9182C13.1438 22.5842 12.7817 22.8732 12.2386 22.9732C11.6956 23.0732 10.9581 22.8954 10.3132 22.2577C9.48732 21.4415 6.47614 18.3707 5.11329 16.9793C4.50987 16.363 3.68349 16.0177 2.82325 16.0177H2.05421C1.93826 16.016 1.82314 16.0374 1.71555 16.0807C1.60795 16.1239 1.51002 16.1881 1.42745 16.2695C1.34487 16.3509 1.2793 16.4479 1.23455 16.5549C1.18979 16.6619 1.16675 16.7767 1.16675 16.8927C1.16675 17.0086 1.18979 17.1234 1.23455 17.2304C1.2793 17.3374 1.34487 17.4344 1.42745 17.5158C1.51002 17.5972 1.60795 17.6614 1.71555 17.7046C1.82314 17.7479 1.93826 17.7693 2.05421 17.7677H2.82325C3.21835 17.7677 3.58837 17.9231 3.86345 18.204C5.22711 19.5963 8.20987 22.6392 9.08269 23.5019C10.0891 24.4969 11.3869 24.9099 12.5553 24.6947C13.5028 24.5203 14.3326 23.8595 14.7474 22.9174C15.7453 22.8342 16.512 22.3759 16.9748 21.8293C16.9865 21.83 16.9983 21.8303 17.0101 21.8305C17.0101 21.8305 19.6432 21.8764 21.1082 21.8305C22.1274 21.7989 23.1548 21.453 24.0614 20.6581C24.4703 20.2998 24.9623 20.0999 25.4627 20.0999H25.9709C26.0868 20.1015 26.2019 20.0801 26.3095 20.0368C26.4171 19.9936 26.5151 19.9294 26.5976 19.848C26.6802 19.7666 26.7458 19.6696 26.7905 19.5626C26.8353 19.4556 26.8583 19.3408 26.8583 19.2249C26.8583 19.1089 26.8353 18.9941 26.7905 18.8871C26.7458 18.7801 26.6802 18.6831 26.5976 18.6017C26.5151 18.5203 26.4171 18.4561 26.3095 18.4129C26.2019 18.3696 26.0868 18.3482 25.9709 18.3499H25.4627C24.4979 18.3499 23.6019 18.7345 22.9084 19.3422C22.2714 19.9007 21.7657 20.0596 21.0547 20.0816H21.0536C20.5758 20.0966 19.9104 20.0935 19.2842 20.093C19.7306 19.7251 20.1309 19.1902 20.3779 18.4752C21.3889 18.2441 22.2457 17.6764 22.5666 16.7913C22.9627 15.6988 22.6546 14.3783 21.6825 13.3835C20.9459 12.6294 17.6755 8.98576 17.6755 8.98576C17.5607 8.85774 17.4108 8.76634 17.2445 8.72298C17.0781 8.67962 16.9027 8.68622 16.7401 8.74195C16.7401 8.74195 13.4077 9.85165 10.9523 9.85165C10.5888 9.85165 10.2725 9.80907 9.99529 9.73999C9.6461 9.6528 9.51416 9.4267 9.48374 9.13387C9.45348 8.84272 9.5493 8.58566 9.84262 8.43661L12.5816 7.29957C12.6168 7.28473 12.6511 7.26761 12.6841 7.24829L15.6782 5.51766C16.3398 5.18834 17.0427 5.16354 17.68 5.41854L21.6232 6.99537C22.0714 7.17538 22.5498 7.26638 23.0314 7.26652L25.9709 7.26766C26.0868 7.2693 26.2019 7.24788 26.3095 7.20465C26.4171 7.16141 26.5151 7.09722 26.5976 7.0158C26.6802 6.93439 26.7458 6.83738 26.7905 6.7304C26.8353 6.62343 26.8583 6.50862 26.8583 6.39266C26.8583 6.2767 26.8353 6.1619 26.7905 6.05493C26.7458 5.94795 26.6802 5.85094 26.5976 5.76952C26.5151 5.68811 26.4171 5.62392 26.3095 5.58068C26.2019 5.53744 26.0868 5.51602 25.9709 5.51766L23.0326 5.51652C22.7725 5.51652 22.5159 5.46817 22.2761 5.37183L22.2738 5.37069L18.3306 3.79387C17.7796 3.5734 17.1917 3.47735 16.6056 3.50448Z"
                    fill="#1B1C1E"
                  />
                </svg>
              </div>
            </div>
            <div className="flex-grow-1 d-flex align-items-center ml-10">
              <div className="introduction-content pb-0">
                <p>
                  When you receive an introduction to your want-ad you'll see it
                  here
                </p>
              </div>
            </div>
          </div>
        )}

        {!isLoadIntroList && !isListItems ? (
          <IntroductionSkeleton />
        ) : (
          isListItems &&
          list.map((intro, index) => {
            if (index === 19) {
              arrayCount = 0;
            }
            const bedRooms = _.get(intro, "Bedrooms", null);
            const bathRooms = _.get(intro, "Bathrooms", null);
            const sqFt = _.get(intro, "Sqft", null);
            const firstName = _.get(intro, "FirstName", "");
            const lastName = _.get(intro, "LastName", "");
            const fullName = firstName + " " + lastName;
            const askingPrice = _.get(intro, "AskingPrice", "");
            const lotType = _.get(intro, "LotType_Rural_City", "");
            const readStatus = _.get(intro, "ReadStatus", false);
            const wantAdId = _.get(intro, "Want_ad_Id", "");
            const inventoryImage =
              _.get(intro, "Photo_1", "") !== "null" &&
              _.get(intro, "Photo_1", "") !== "undefined" &&
              _.get(intro, "Photo_1", "") !== null
                ? _.get(intro, "Photo_1", "")
                : noImage;
            const nameOfTheIntroducer = fullName
              ?.replace(/-/g, "")
              ?.match(/\b(\w)/g);
            const introId = _.get(intro, "IntroductionId", "");
            const introCreatedDate = _.get(intro, "CreatedOn", null);
            const acreage = _.get(intro, "TotalAcre", "");
            const profImgClass =
              "intro-prof-wrap intro-prof-fix " + classArray[arrayCount];
            arrayCount++;
            return (
              <>
                <div className="intro-outer-sec notify-info-bg">
                  <div
                    className="introduction-sec align-items-center mb-2"
                    onMouseEnter={() =>
                      !readStatus &&
                      updateIntroStateonHover(
                        _.get(intro, "IntroductionId", "")
                      )
                    }
                    key={index}
                  >
                    <div className="flex-shrink-0">
                      <div className={profImgClass}>
                        <img src={profImg} alt=""></img>
                      </div>
                    </div>
                    <div
                      className="flex-grow-1 ml-10"
                      onClick={(e) => {
                        viewIntroductions(wantAdId, introId);
                        e.stopPropagation();
                      }}
                    >
                      <div className="introduction-content pb-0">
                        <p>
                          You received an introduction to your ad{" "}
                          <span className="long-txt-fix">
                            {_.get(intro, "Title_Text", "")}
                          </span>
                        </p>
                        <span className="time-stamp">
                          {introCreatedDate &&
                            timeAgo(moment.utc(introCreatedDate).toISOString())}
                        </span>
                      </div>
                    </div>

                    {!readStatus && (
                      <div className="dot-indicator dot-bg-red align-self-center flex-shrink-0 mt-0"></div>
                    )}
                  </div>
                  <div className="outer-property-wrap ml-20 mr-20 pb-12">
                    <div
                      className="add-your-property-wrap bg-white mb-0 flex-grow-1"
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                      role="button"
                      onKeyDown={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      <div className="make-intro-img">
                        <img src={inventoryImage} alt={inventoryImage} />
                      </div>
                      <div className="make-intro-details">
                        <h3 className="mb-0 long-txt-fix intro-head-normal f-regular">
                          {getpropertyName(intro)}{" "}
                          <span className=" long-txt-fix">in</span>{" "}
                          {_.get(intro, "City", "")},{" "}
                          {_.get(intro, "State", "")}
                        </h3>

                        {_.get(intro, "PropertyTypeId", "") === IS_LAND ? (
                          <ul className="intro-icons-list">
                            {acreage && (
                              <li>
                                <span className="list-txt">
                                  {removeDecimalZeros(acreage)}
                                  {_.get(intro, "Acre_Sqft", "")}
                                </span>
                                <div className="	list-icns">
                                  <img src={SqftIcon} />
                                </div>
                              </li>
                            )}

                            {lotType && (
                              <li>
                                <span className="list-txt">
                                  {filterArray(LOT_TYPES, "value", lotType)}
                                </span>
                              </li>
                            )}
                          </ul>
                        ) : (
                          <ul className="intro-icons-list">
                            {bedRooms && (
                              <li>
                                <span className="list-txt">
                                  {removeDecimalZeros(bedRooms)}{" "}
                                </span>
                                <div className="	list-icns">
                                  <img src={BedIcon} />
                                </div>
                              </li>
                            )}

                            {bathRooms && (
                              <li>
                                <span className="list-txt">
                                  {removeDecimalZeros(bathRooms)}{" "}
                                </span>
                                <div className="	list-icns">
                                  <img src={BathIcon} />
                                </div>
                              </li>
                            )}
                            {sqFt && (
                              <li>
                                <span className="list-txt">
                                  {removeDecimalZeros(sqFt)}
                                  {" SQFT "}
                                </span>
                                <div className="	list-icns">
                                  <img src={SqftIcon} />
                                </div>
                              </li>
                            )}
                          </ul>
                        )}

                        <div className="intro-amt">
                          ${askingPrice && thousandSeperatedValue(askingPrice)}
                        </div>
                      </div>

                      <button
                        type="button"
                        className="btn btn-outline-primary "
                        onClick={(e) => {
                          viewIntroductions(wantAdId, introId);
                          e.stopPropagation();
                        }}
                      >
                        View
                      </button>
                    </div>
                  </div>
                </div>
              </>
            );
          })
        )}
      </div>
    </>
  );
};
export default Introductions;
